import React from 'react';
import { BookOpenIcon, ClockIcon, FlagIcon, Gamepad2Icon, MessagesSquareIcon, PrinterIcon } from 'lucide-react';
import { meetingComponents, meetings } from '../data/landing';
import { SectionHeading } from './SectionHeading';
const icons = {
  clock: ClockIcon,
  game: Gamepad2Icon,
  book: BookOpenIcon,
  chat: MessagesSquareIcon,
  flag: FlagIcon,
  print: PrinterIcon
};
export function ContentsSection() {
  return <section className="bg-white py-12 md:py-24" data-id="element-50" data-mp="2cumnht6cs7vx">
      <div className="mx-auto max-w-[1180px] px-5 md:px-8" data-id="element-51" data-mp="2guna413lvpe2">
        <SectionHeading eyebrow="What's inside" title="Every meeting," highlight="fully built." description="Each of the 12 meetings follows the same clear structure, so you always know what to prepare, say, ask, and send home." data-id="element-52" data-mp="2gv6hinvmqvdu" />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-53" data-mp="1t4kjzqj94ti3">
          {meetingComponents.map(item => {
          const Icon = icons[item.icon];
          return <article key={item.title} className="flex gap-4 rounded-2xl border border-navy/[0.08] bg-white p-6 shadow-[0_10px_30px_rgba(20,33,61,0.06)]" data-id="element-54" data-mp="1obzq6rs7chz3">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal/10 text-teal" data-id="element-55" data-mp="1fjfzcdi5jhot">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-56" data-mp="1ale3st3jhpwg" />
                </div>
                <div data-id="element-57" data-mp="15ncp0kd5ccqs">
                  <h3 className="font-display text-[22px] font-bold uppercase leading-tight text-navy" data-id="element-58" data-mp="15kgmsju9n1wj">{item.title}</h3>
                  <p className="mt-1 text-[15px] text-muted" data-id="element-59" data-mp="wlv9b33nid2m">{item.body}</p>
                </div>
              </article>;
        })}
        </div>

        <div className="mt-14 text-center md:mt-20" data-id="element-60" data-mp="rocwv2qfdfpv">
          <h3 className="font-display text-[clamp(32px,4vw,44px)] font-extrabold uppercase leading-none text-navy" data-id="element-61" data-mp="2qzmi60e5osx0">
            The <span className="text-teal" data-id="element-62" data-mp="2m1uob0tyawq6">12 meetings</span>
          </h3>
          <p className="mt-3 text-muted" data-id="element-63" data-mp="355oesq7aj8ga">Follow the suggested order or choose the meeting that fits your group.</p>
        </div>
        <ol className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" data-id="element-64" data-mp="39x6ezc1hp507">
          {meetings.map((meeting, index) => <li key={meeting} className="flex flex-col overflow-hidden rounded-xl border border-navy/[0.08] bg-white shadow-[0_8px_24px_rgba(20,33,61,0.06)]" data-id="element-65" data-mp="2w6ktrgokciz5" data-mpi={index}>
              <div className="flex items-end justify-between border-b-4 border-teal bg-navy px-4 pb-2 pt-4" data-id="element-66" data-mp="3ou702wp6e1pp">
                <span className="font-display text-[44px] font-extrabold leading-none text-amber" data-id="element-67" data-mp="3sswfsvxorvci">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="pb-1 text-[9px] font-bold uppercase tracking-[1.8px] text-teal-light" data-id="element-68" data-mp="3jsrbiunshd2k">Week {index + 1}</span>
              </div>
              <p className="flex-1 p-4 text-sm font-semibold leading-snug text-navy" data-id="element-69" data-mp="28evxjp8mfacx">{meeting}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}